import React from 'react';

import CommandForDJI from './dji';
import CommandForMavlink from './mavlink';

const Command = ({ protocol, ...props }) => {
  if (protocol === 'dji') {
    return <CommandForDJI {...props} />;
  }

  if (protocol === 'mavlink') {
    return <CommandForMavlink {...props} />;
  }

  return null;
};

export default Command;
